<template>
  <router-view />
</template>

<script>
export default {
  name: 'IslandVacationGroupsIndex'
}
</script>
